import { API_URL } from '../config';

// Compteur des messages admin non lus, demandé par la barre latérale ET par l'en-tête.
// Les deux appels simultanés partagent une requête (audit 2026-10-01 : 30 appels par session).
const DUREE_MS = 10_000;
let enCours: { jeton: string; quand: number; promesse: Promise<number | null> } | null = null;

export const adminMessagesService = {
  /** Nombre de messages non lus, ou null si la requête a échoué (le compteur affiché reste alors inchangé). */
  getUnreadCount: (jeton: string): Promise<number | null> => {
    if (enCours && enCours.jeton === jeton && Date.now() - enCours.quand < DUREE_MS) {
      return enCours.promesse;
    }
    const promesse = fetch(`${API_URL}/v1/admin/messages/unread-count`, {
      headers: { Authorization: `Bearer ${jeton}` },
    })
      .then(async (response) => (response.ok ? ((await response.json()).unread_count as number) || 0 : null))
      .catch(() => null);
    enCours = { jeton, quand: Date.now(), promesse };
    return promesse;
  },
};
